export type AutomationTab = 'rules' | 'messages'

export const AUTOMATION_TABS: readonly AutomationTab[] = ['rules', 'messages']

export function resolveAutomationTab(requested: string | null | undefined): AutomationTab {
  return AUTOMATION_TABS.find((tab) => tab === requested) ?? AUTOMATION_TABS[0]
}
